<template>
  <div v-if="shown"
       class="text-center bg-danger text-white small header-warning-panel">
    <slot/>
    <router-link class="text-white text-underlined ml-2"
                 v-if="linkTo"
                 :to="linkTo">{{ linkText }}
    </router-link>
    <a @click="closed = true" class="close-svg pointer"><CloseSvg/></a>
  </div>
</template>

<script setup>
import { ref, computed } from "vue"
import CloseSvg from '@/assets/svg-vue/general/close.svg'

const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  linkTo: {
    type: String,
    default: null
  },
  linkText: {
    type: String,
    default: null
  }
})

const closed = ref(false)
const shown = computed(() => props.visible && !closed.value)
</script>

<style scoped>
.header-warning-panel {
  position: relative;
  padding: 2px 15px;
  z-index: 20;
}
.close-svg svg {
  fill: #fff;
  width: 10px;
  height: 10px;
  position: absolute;
  right: 15px;
  top: 6px;
}
@media(max-width: 768px) {
  .close-svg svg {
    width: 8px;
    height: 8px;
    top: 5px;
  }
}
</style>
